export default "__VITE_ASSET__NBLBZjMi__"